import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useIsMobile from "../../../../../../../../core/hooks/useIsMobile";
import { actions, useAppSelector } from "../../../../../../../../core/store";
import * as selectors from "../../../../../../../../core/store/selectors";
import {
  AddEditModalValuesMultiple,
  setCurrentEditModalValuesMultiple,
  setCurrentEditModalValuesNEW,
} from "../../../../../../../../core/store/thunk/newOrder";
import withFormHocs from "../../../../../../hoc/withFormHocs";
import { FieldModal, PropsField } from "../../../../../../types/bigForm";
import classes from "../../../../OrderBody.module.scss";
import ModalField from "../modal-field/ModalField";

type Props = PropsField & {
  value?: FieldModal | FieldModal[];
};

const GroupField: React.FC<Props> = ({
  field,
  propsalId,
  propsalIdsReal,
  handleSaveDraftOnBlur,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isError, setIsError] = useState<boolean>();
  const groupFieldsErrors = useSelector(selectors.groupFieldsErrors);
  const dispatch = useDispatch();
  const { currentModalData, currentEditModal } = useAppSelector(
    (state) => state.newOrder
  );
  const isMobile = useIsMobile();
  const handleAddNewModal = () => {
    dispatch(AddEditModalValuesMultiple(field.name, undefined));
  };

  const handleDeleteModalByIndex = (modalIndex: number) => {
    if (modalIndex !== undefined) {
      console.log(
        "setCurrentEditModalValuesMultiple delete modalIndex",
        modalIndex
      );
      actions.deleteMultipleModalAccordion({
        propsalId: propsalId,
        fieldName: field.name,
        index: modalIndex,
      });
      if (handleSaveDraftOnBlur) {
        console.log(
          "setCurrentEditModalValuesMultiple delete on blur modalIndex",
          modalIndex
        );
        handleSaveDraftOnBlur();
      }
    }
  };

  function safeJSONParse(str: string, fallback = []) {
    try {
      return JSON.parse(str);
    } catch (e) {
      console.log("Error parsing JSON:", e);
      return fallback;
    }
  }

  useEffect(() => {
    if (currentModalData?.modalName !== field?.name) {
      actions.setCurrentEditModalMultiple({
        values: undefined,
        errors: undefined,
        modalIndex: 0,
      });
      actions.setCurrentModalData({
        propsalId: propsalId,
        modalName: field.name,
        index: undefined,
        isMultiple: field.isMultiple,
        proposals: propsalIdsReal,
      });

      actions.setCurrentEditModal({
        values: undefined,
        errors: undefined,
        modalIndex: 0,
      });

      if (field && field.isMultiple === false) {
        console.log("setCurrentEditModalValues", field);
        dispatch(setCurrentEditModalValuesNEW(field.name, undefined));
      } else if (field && field.isMultiple === true) {
        console.log("setCurrentEditModalValuesMultiple", field);
        if (typeof field.values === "string") {
          field.values = safeJSONParse(field.values, []);
        }
        if (field.values.length > 0) {
          dispatch(setCurrentEditModalValuesMultiple(field.name, undefined));
        }
      }
    }
    return () => {
      actions.setCurrentModalData({
        propsalId: undefined,
        modalName: undefined,
        index: undefined,
        isMultiple: undefined,
        proposals: undefined,
      });
      actions.setCurrentEditModalMultiple({
        values: undefined,
        errors: undefined,
        modalIndex: 0,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [field]);

  useEffect(() => {
    if (groupFieldsErrors) {
      const propsalGroupField = groupFieldsErrors[propsalId];
      if (propsalGroupField) {
        if (propsalGroupField[field.name]) {
          setIsError(propsalGroupField[field.name]);
        } else {
          setIsError(undefined);
        }
      } else {
        setIsError(undefined);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupFieldsErrors]);

  return (
    <>
      {field?.isMultiple ? (
        <>
          {currentEditModal.values?.map((el, index) => (
            <React.Fragment key={index}>
              {currentEditModal?.values?.[index] && (
                <ModalField
                  modal={field.name}
                  propsalId={propsalId}
                  modalIndex={index}
                  propsalIdsReal={propsalIdsReal}
                  isMultiple={true}
                />
              )}
              {/* logic to not deleting the only one */}
              {!field?.isRequeired ? (
                <div
                  className={`blue_link ${classes.end}`}
                  onClick={() => handleDeleteModalByIndex(index)}
                >
                  удалить
                </div>
              ) : (
                currentEditModal &&
                currentEditModal.values &&
                currentEditModal.values.length > 1 && (
                  <div
                    className={`blue_link ${classes.end}`}
                    onClick={() => handleDeleteModalByIndex(index)}
                  >
                    удалить
                  </div>
                )
              )}
              {isMobile && <div className="line_x" />}
            </React.Fragment>
          ))}
          <button className="button_secondary_w100" onClick={handleAddNewModal}>
            Добавить
          </button>
        </>
      ) : (
        <ModalField
          modal={field.name}
          propsalId={propsalId}
          modalIndex={0}
          propsalIdsReal={propsalIdsReal}
          isMultiple={false}
        />
      )}
    </>
  );
};

export default withFormHocs(GroupField);
